import React from "react";
import IndustryCard from "./IndustryCard";

const industries = [
  {
    image: "/Images/homeCompany.webp",
    imagePosition: "center 40%",
    category: "Production",
    title: "Manufacturing",
    description:
      "Connect planning, purchasing, production, costing and inventory within one integrated business system.",
    capabilities: [
      "Bills of material",
      "Production planning",
      "Inventory costing",
      "Procurement visibility",
    ],
    cta: "Explore Manufacturing Solutions",
  },
  {
    image: "/Images/computer.jpg",
    imagePosition: "center",
    category: "Process Industries",
    title: "Industrial Gases & Chemicals",
    description:
      "Improve visibility across procurement, inventory, cylinder movement, sales, finance and compliance processes.",
    capabilities: [
      "Cylinder and inventory tracking",
      "Customer and vendor management",
      "GST and financial reporting",
      "Multi-location visibility",
    ],
    cta: "Explore Industrial Solutions",
  },
  {
    image: "/Images/about1.png",
    imagePosition: "center",
    category: "Distribution",
    title: "Trading & Distribution",
    description:
      "Coordinate purchasing, warehouses, sales, receivables and fulfilment with accurate real-time information.",
    capabilities: [
      "Purchasing and sales",
      "Warehouse visibility",
      "Order fulfilment",
      "Receivables management",
    ],
    cta: "Explore Distribution Solutions",
  },
  {
    image: "/Images/webh.webp",
    imagePosition: "center 30%",
    category: "Commerce",
    title: "Retail & E-commerce",
    description:
      "Connect products, inventory, customer orders and digital commerce workflows across sales channels.",
    capabilities: [
      "Product management",
      "Inventory visibility",
      "Customer-order workflows",
      "Business integrations",
    ],
    cta: "Explore Retail Solutions",
  },
  {
    image: "/Images/mobilehome.jpg",
    imagePosition: "center 40%",
    category: "Resource Industries",
    title: "Mining & Building Materials",
    description:
      "Bring greater control to material movement, purchasing, sales, expenses and division-wise financial reporting.",
    capabilities: [
      "Material and stock visibility",
      "Purchase and sales management",
      "Cost-centre reporting",
      "Division-wise analysis",
    ],
    cta: "Explore Resource Industry Solutions",
  },
  {
    image: "/Images/hero/abscod-team-hero.webp",
    imagePosition: "center 30%",
    category: "Service Businesses",
    title: "Professional Services",
    description:
      "Manage clients, projects, resources, expenses and billing with improved operational and financial visibility.",
    capabilities: [
      "Project costing",
      "Resource visibility",
      "Expense management",
      "Client billing",
    ],
    cta: "Explore Professional Services Solutions",
  },
];

const Industries = () => {
  return (
    <section className="relative overflow-hidden bg-white py-20 md:py-24 lg:py-28">
      {/* Ambient glows */}
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-[28rem] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-500/[0.04] blur-[120px]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute right-0 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-violet-500/[0.04] blur-[110px]"
        aria-hidden="true"
      />

      <div className="relative z-10 mx-auto w-full max-w-[1340px] px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="about-fade-up mx-auto max-w-3xl text-center">
          <span className="inline-block rounded-full border border-slate-200 bg-white px-4 py-1.5 text-sm font-bold tracking-[0.12em] text-slate-600 uppercase shadow-sm">
            INDUSTRIES WE SERVE
          </span>

          <h2 className="mt-5 font-raleway font-extrabold leading-[1.12] tracking-tight text-slate-900 text-[clamp(1.75rem,4vw,2.75rem)]">
            Business solutions designed around how{" "}
            <span className="text-[#FFDB16] drop-shadow-[0_0_20px_rgba(255,219,22,0.4)]">
              your industry works
            </span>
            .
          </h2>

          <p className="mt-5 font-openSans text-base leading-relaxed text-slate-600 md:text-lg">
            Every industry has different processes, controls and reporting
            requirements. Abscod configures Business Central and connected
            solutions around the operational realities of your business.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {industries.map((industry, index) => (
            <div
              key={industry.title}
              style={{ animationDelay: `${(index + 1) * 0.05}s` }}
              className="about-fade-up"
            >
              <IndustryCard {...industry} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
